export default __webpack_public_path__ + "static/media/doctor.aab194b5.png";